<template>
  <div class="test">
    <router-view></router-view>
  </div>

</template>

<script>

  export default {
    name: 'LoggedUser',
    components: {

    }
  };

</script>
